import { useQuery } from "@tanstack/react-query";
import { useNotifications } from "../NotificationProvider";

export const useAllNotifications = (userId: string) => {
    const { getNotifications } = useNotifications();

    return useQuery(
        ["notifications", userId],
        () => getNotifications({ params: {} }),
        {
            enabled: !!userId,
            refetchInterval: 60000 * 3,
        },
    );
};

export const useUnreadNotifications = (userId: string) => {
    const { getNotifications } = useNotifications();

    return useQuery(
        ["unreadNotifications", userId],
        () => getNotifications({ params: { isRead: false } }),
        {
            enabled: !!userId,
            refetchInterval: 60000 * 3,
        },
    );
};
